import { TOGGLE_OPTIONAL_MAP_ATTRIBUTION, CHANGE_MAP_ATTRIBUTION_POSITION } from './constants';
import { createReducer, baseReduceHandler } from '../reducer';
export const reducer = createReducer({}, {
    [TOGGLE_OPTIONAL_MAP_ATTRIBUTION]: baseReduceHandler,
    [CHANGE_MAP_ATTRIBUTION_POSITION]: baseReduceHandler,
});
//# sourceMappingURL=reducer.js.map